const MYSQL_UTC_TIMESTAMP_PATTERN = /^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/

export const resolveUserTimeZone = () => {
  return Intl.DateTimeFormat().resolvedOptions().timeZone || 'UTC'
}

export const parseVersionHistoryTimestamp = (timestamp) => {
  if (!timestamp) return null

  if (timestamp instanceof Date) {
    return Number.isNaN(timestamp.getTime()) ? null : timestamp
  }

  const normalizedTimestamp = typeof timestamp === 'string' && MYSQL_UTC_TIMESTAMP_PATTERN.test(timestamp)
    ? `${timestamp.replace(' ', 'T')}Z`
    : timestamp

  const parsed = new Date(normalizedTimestamp)
  if (!Number.isNaN(parsed.getTime())) return parsed

  if (typeof timestamp !== 'string') return null

  const fallback = new Date(timestamp.replace(' ', 'T'))
  return Number.isNaN(fallback.getTime()) ? null : fallback
}

export const formatVersionHistoryTimestamp = (timestamp, timeZone = resolveUserTimeZone()) => {
  const date = parseVersionHistoryTimestamp(timestamp)
  if (!date) return ''

  return new Intl.DateTimeFormat('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    timeZone
  }).format(date)
}

export const formatVersionHistoryTimeAgo = (timestamp, options = {}) => {
  const { now = new Date(), timeZone = resolveUserTimeZone() } = options
  const date = parseVersionHistoryTimestamp(timestamp)
  if (!date) return ''

  const diffMs = Math.max(0, now.getTime() - date.getTime())
  const diffMins = Math.floor(diffMs / 60000)
  const diffHours = Math.floor(diffMs / 3600000)
  const diffDays = Math.floor(diffMs / 86400000)

  if (diffMins < 1) return 'Just now'
  if (diffMins === 1) return '1 minute ago'
  if (diffMins < 60) return `${diffMins} minutes ago`
  if (diffHours === 1) return '1 hour ago'
  if (diffHours < 24) return `${diffHours} hours ago`
  if (diffDays === 1) return 'Yesterday'
  if (diffDays < 7) return `${diffDays} days ago`

  return new Intl.DateTimeFormat('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    timeZone
  }).format(date)
}
